import type { ReactNode } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import AppShell from './components/AppShell/AppShell';

import { routes } from './constants/routes';

const router = (rootElement: ReactNode) =>
  createBrowserRouter([
    {
      path: '',
      element: (
        <>
          <AppShell />
          {rootElement}
        </>
      ),
      children: routes,
    },
  ]);

function App({ children = <Outlet /> }: { children?: ReactNode }) {
  return (
    <div id="App">
      <RouterProvider router={router(children)} />
    </div>
  );
}

export default App;
